import { alpha } from '@mui/material/styles';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import useResponsive from '../../hooks/useResponsive';
import Iconify from '../Iconify';
import { useSpotlight } from './SpotlightProvider';
import { Kbd, MOD_KEY } from './SpotlightDialog';

// The header's way into the Ctrl+K palette: a search pill on desktop, a
// magnifier below lg. Renders nothing outside OrgLayout (no provider).

export default function SpotlightTrigger() {
  const spotlight = useSpotlight();
  const isDesktop = useResponsive('up', 'lg');

  if (!spotlight) return null;

  if (!isDesktop) {
    return (
      <IconButton aria-label="Search" onClick={() => spotlight.openSpotlight()} sx={{ color: 'text.primary', mr: 0.5 }}>
        <Iconify icon="solar:magnifer-linear" width={22} />
      </IconButton>
    );
  }

  return (
    <Tooltip title={`Search everything (${MOD_KEY} K)`}>
      <Box
        role="button"
        tabIndex={0}
        aria-label="Search"
        onClick={() => spotlight.openSpotlight()}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            spotlight.openSpotlight();
          }
        }}
        sx={{
          ml: 2,
          pl: 1.5,
          pr: 1,
          height: 40,
          width: { lg: 340, xl: 420 },
          flexShrink: 1,
          minWidth: 200,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          cursor: 'pointer',
          borderRadius: 1.25,
          color: 'text.disabled',
          bgcolor: (t) => alpha(t.palette.grey[500], 0.08),
          border: (t) => `1px solid ${alpha(t.palette.grey[500], 0.16)}`,
          transition: (t) => t.transitions.create(['background-color', 'border-color']),
          '&:hover, &:focus-visible': {
            outline: 'none',
            bgcolor: (t) => alpha(t.palette.primary.main, 0.06),
            borderColor: (t) => alpha(t.palette.primary.main, 0.32),
          },
        }}
      >
        <Iconify icon="solar:magnifer-linear" width={20} sx={{ color: 'text.secondary', flexShrink: 0 }} />
        <Typography variant="body2" noWrap sx={{ flex: 1, color: 'text.disabled' }}>
          Search members, invoices, leads…
        </Typography>
        <Kbd>{MOD_KEY} K</Kbd>
      </Box>
    </Tooltip>
  );
}
